"use client";
import { useRouter, useSearchParams } from "next/navigation";

type ArticlesProps = {
  initialMeta: {
    pagination: {
      page: number;
      pageSize: number;
      pageCount: number;
      total: number;
    };
  };
  currentPage: number;
};

const _components: React.FC<ArticlesProps> = ({ initialMeta, currentPage }) => {
  const hasMore =
    initialMeta.pagination.page < initialMeta.pagination.pageCount;
  const router = useRouter();
  const searchParams = useSearchParams();

  const { pageCount } = initialMeta.pagination;

  const handlePageChange = (newPage: number) => {
    if (newPage < 1 || newPage > pageCount) return;

    if (newPage === 1) {
      // Remove os parâmetros da URL
      router.push("/blog", { scroll: false });
    } else {
      const params = new URLSearchParams(searchParams.toString());
      params.set("page", newPage.toString());

      router.push(`?${params.toString()}`, { scroll: false });
    }

    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <div className="flex justify-between gap-3 mt-6">
        {/* Botão de voltar */}
        {currentPage > 1 && (
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            className="border-gray-400 border bg-white text-gray-500 font-light py-2 px-4 rounded-lg disabled:opacity-50"
          >
            Voltar Página
          </button>
        )}

        {/* Botão de carregar mais */}
        {hasMore && (
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            className="border-gray-400 border bg-white text-gray-500 font-light py-2 px-4 rounded-lg disabled:opacity-50"
          >
            Carregar Mais
          </button>
        )}
      </div>
    </>
  );
};

export default _components;
